module.exports = __webpack_public_path__ + "static/media/88.52586942.png";